import React, { useState } from "react";
import { Tag } from "primereact/tag";
import "../ModuleGrids/ModuleGrids.scss";
import { NavLink } from "react-router-dom";

export const taskNameCell = (fieldName, handleApproveDialogCPPFA) => (rowData) => {
  const taskId = rowData?.AWMTaskID;
  const projectID = rowData?.AWMProjectID;
  const TaskCode = taskId?.split("_");
  const assignee = rowData?.Assignee;
  
  const url = `${TaskCode[0]}/${taskId}/${projectID}`;
  const artworkAlignmentUrl = `/allTasks/artworkAlignment/${assignee}/${projectID}`;
  const dependencyMapping = `/allTasks/dependencyMapping/${projectID}`;

  return (
    <div className="flex align-items-center">
      {(TaskCode[0] === "SAA" || TaskCode[0] === "TPOA") && (
        <NavLink className="task_name task_link" to={artworkAlignmentUrl}>
          {rowData?.[fieldName]}
        </NavLink>
      )}
      {TaskCode[0] === "CPPFA" && (
        <NavLink className="task_name task_link" to="" onClick={(e) => handleApproveDialogCPPFA(e, rowData)}>
          {rowData?.[fieldName]}
        </NavLink>
      )}
      {TaskCode[0] === "UBD" && (
        <NavLink className="task_name task_link" to={url}>
          {rowData?.[fieldName]}
        </NavLink>
      )}
      {TaskCode[0] === "RWK" && (
        <NavLink className="task_name task_link" to={`${window?.location?.pathname}/RWK/${taskId}/${projectID}`}>
          {rowData?.[fieldName]}
        </NavLink>
      )}
      {TaskCode[0] !== "CPPFA" &&
        TaskCode[0] !== "SAA" &&
        TaskCode[0] !== "RCIC" &&
        TaskCode[0] !== "RCICMatrix" &&
        TaskCode[0] !== "DM" &&
        TaskCode[0] !== "TPOA" &&
        TaskCode[0] !== "UBD" &&
        TaskCode[0] !== "RWK" && (
          <NavLink className="task_name task_link" to={url}>
            {rowData?.[fieldName]}
          </NavLink>
        )}
      {(TaskCode[0]?.includes("RCIC") || TaskCode[0]?.includes("DM")) && (
        <NavLink className="task_name task_link" to={dependencyMapping}>
          {rowData?.[fieldName]}
        </NavLink>
      )}
    </div>
  );
}

// Status cell with color class
export const statusCell = (rowData) => {
  const getStatusColor = (status) => {
    switch (status) {
      case "In-Progress":
        return "#ddebf7";
      case "Awaiting":
        return "#fff2cc";
      case "Complete":
        return "#ccffcc";
      case "Complete-Rejected":
        return "#ff8f8f";
      case "Complete-Approved":
        return "#ccffcc";
      default:
        return "";
    }
  };

  const backgroundColor = getStatusColor(rowData?.Status);

  return (
    <div
      className="status-cell"
      style={{ "--status-color": backgroundColor }}
    >
      {rowData?.Status}
    </div>
  );
};

// Tooltip cell - displays cell value with tooltip on hover
export const tooltipCell = (fieldName) => (rowData) => (
  <span title={rowData?.[fieldName]}>{rowData?.[fieldName]}</span>
);

export const helpNeededCell = (mode) => (rowData) => {
  let className = "";
  let helpNeeded = rowData?.HelpNeeded;
  switch (helpNeeded) {
    case "Yes, In Process":
      className = mode === "max" ? "help-in-process" : "helpneeded_inprocess";
      break;
    case "Yes, Done":
      className = mode === "max" ? "help-done" : "helpneeded_done";
      break;
    case "N/A":
      className = "helpneeded_no";
      break;
    case "":
      className = "helpneeded_no";
      rowData["HelpNeeded"] = "No";
      break;
    case "No":
      className = "helpneeded_no";
      break;
    default:
      break;
  }
  // Show message icon if comments or help needed reason exist
  const hasMessage = rowData?.HelpNeeded || rowData?.Comments;
  return (
    <div
      className={mode === "max" ? "d-flex align-items-center justify-content-between" : undefined}
    >
      <span className={className} style={{ fontSize: mode === "max" ? undefined : "10px" }}>
        {rowData?.HelpNeeded}
      </span>
      {/* {mode === "max" && hasMessage && (
        <img
          src={messageIcon}
          alt="message"
          className="message-icon"
          style={{ cursor: "pointer", marginLeft: "8px", width: "18px", height: "18px" }}
          onClick={() => {
            // Optionally handle message dialog here
          }}
        />
      )} */}
    </div>
  );
};

// Project ID cell with navigation
export const projectIdCell = (baseUrl, dispatch, SpecialProjectAction) => (rowData) => {
  const projectId = rowData?.AWMProjectID;
  return (
    <span
      className="project-link"
      style={{ cursor: "pointer" }}
      onClick={() => {
        if (dispatch && SpecialProjectAction) {
          dispatch(SpecialProjectAction(rowData?.SpecialProject));
        }
        let url;
        if (rowData?.SpecialProject === "Yes") {
          url = `${baseUrl}/artworkStatus/${projectId}`;
        } else {
          if (rowData?.Action === "Draft") {
            url = `${baseUrl}/projectSetup/${projectId}`;
          } else {
            url = `${baseUrl}/projectPlan/${projectId}`;
          }
        }
        window.open(url, "_blank");
      }}
    >
      {projectId}
    </span>
  );
};

// Project Name cell with navigation
export const projectNameCell = (baseUrl) => (rowData) => {
  const projectId = rowData?.AWMProjectID;
  return (
    <span
      className="project-link"
      style={{ cursor: "pointer" }}
      onClick={() => {
        let url;
        if (rowData?.SpecialProject === "Yes") {
          url = `${baseUrl}/artworkStatus/${projectId}`;
        } else {
          if (rowData?.ProjectState === "Draft") {
            url = `${baseUrl}/projectSetup/${projectId}`;
          } else {
            url = `${baseUrl}/projectPlan/${projectId}`;
          }
        }
        window.open(url, "_blank", "noopener,noreferrer");
      }}
    >
      {rowData?.ProjectName || rowData?.AWMProjectName}
    </span>
  );
};

export const bufferToWork = (value) => {
  let color;
  if (value <= 0) {
    color = "#FF0000";
  } else if (value > 0 && value <= 0.3) {
    color = "#E2CC00";
  } else if (value > 0.3 && (value != 9999 && value != 9999.00)) {
    color = "#03A000";
  }
  const displayValue = value === "9999.00" || value === "9999" ? "N/A" : value;
  return <span style={{ color }}>{displayValue}</span>;
};

// BufferToWork cell with color
export const bufferToWorkCell = (rowData) =>
  bufferToWork(rowData?.BufferToWorkRatio || rowData?.BufferToWork);

// Artwork Status cell
export const artworkStatusCell = (baseUrl) => (rowData) => {
  const projectId = rowData?.AWMProjectID;
  return (
    <div className="artwork-status-container">
      <Tag
        value="View"
        className="artwork-status-tag"
        onClick={() =>
          window.open(`${baseUrl}/artworkStatus/${projectId}`, "_blank", "noopener,noreferrer")
        }
      />
    </div>
  );
};

// Cell template for displaying an image from FilePath
const ImageCell = ({ src }) => {
  const [hasError, setHasError] = useState(false);

  if (!src) {
    return (
      <div className="image-cell-container">
        <div className="cell-image-placeholder">
          <i className="pi pi-image"></i>
        </div>
      </div>
    );
  }

  if (hasError) {
    return (
      <div className="image-cell-container">
        <div className="cell-image-error">No Visual available</div>
      </div>
    );
  }

  return (
    <div className="image-cell-container">
      <img
        src={src}
        alt="Preview"
        className="cell-image-preview"
        onError={() => setHasError(true)}
      />
    </div>
  );
};

export const filePathImageCell = (rowData) => {
  return <ImageCell src={rowData?.FilePath} />;
};

// Status cell with icon and color for Jobs grid
export const statusIconCell = (rowData) => {
  const getStatusColor = (status) => {
    switch (status) {
      case "Complete-Approved":
        return "#28a745";
      case "In-Progress":
        return "#007bff";
      case "In-Progress-Rejected":
        return "#dc3545";
      case "Complete-Rejected":
        return "#dc3545";
      case "Awaiting":
        return "#ffdb69";
      default:
        return "#6c757d";
    }
  };

  const cellStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: getStatusColor(rowData?.Status),
    fontWeight: 500,
    height: "100%",
    width: "100%",
  };

  const content = (() => {
    if (rowData?.Status === "Complete-Approved") {
      return <i className="pi pi-check"></i>;
    }
    if (rowData?.Status === "In-Progress") {
      return <i className="pi pi-refresh"></i>;
    }
    if (rowData?.Status === "In-Progress-Rejected") {
      return <i className="pi pi-refresh"></i>;
    }
    if (rowData?.Status === "Complete-Rejected") {
      return <i className="pi pi-times"></i>;
    }
    if (rowData?.Status === "Awaiting") {
      return <i className="pi pi-hourglass"></i>;
    }
    return rowData?.Status;
  })();

  return (
    <div className="status-icon-column job-status-cell">
      <span style={cellStyle}>{content}</span>
    </div>
  );
};

/**
 * cicImageClass - Returns the icon class name for a given image/status name
 */
export const cicImageClass = (imageName) => {
  switch (imageName) {
    case "HallowGreyCircle":
      return "pi pi-circle-off footerIconAll footerIcons7";

    case "HallowRedCircle":
      return "pi pi-circle-off footerIconAll footerIcons6";

    case "SolidRedCircle":
      return "pi pi-circle-on footerIconAll footerIcons9";

    case "RedCross":
      return "pi pi-times footerIconAll footerIcons4";

    case "GreenV":
      return "pi pi-check footerIconAll footerIcons3";

    case "HallowGreenCircle":
      return "pi pi-circle-off footerIconAll footerIcons5";

    case "SolidGreenCircle":
      return "pi pi-circle-on footerIconAll footerIcons8";

    case "Awaiting":
      return "pi pi-circle-off footerIconAll footerIcons7";

    case "In Progress":
      return "pi pi-circle-on footerIconAll footerIcons8";

    case "Complete":
      return "pi pi-check footerIconAll footerIcons3";

    default:
      return "";
  }
};

/* CIC/FA Status cell with icons for Jobs grid
   Displays CICFlag or FAFlag as an icon based on the value in the row data
*/
export const cicImage = (rowData, column) => {
  let imageName;

  // Support for independent filtering: when called with direct string values from ACP filter
  if (typeof rowData === "string") {
    imageName = rowData;
  } else if (rowData && typeof rowData === "object") {
    // Use column.field to determine which flag to display (CICFlag or FAFlag)
    if (column?.field === "FAFlag") {
      imageName = rowData?.FAFlag; // FA column: show FAFlag
    } else if (column?.field === "CICFlag") {
      imageName = rowData?.CICFlag; // CIC column: show CICFlag
    } else {
      // Fallback for other uses: try CICFlag first, then FAFlag
      imageName = rowData?.CICFlag || rowData?.FAFlag;
    }
  } else {
    imageName = null;
  }

  const iconClass = cicImageClass(imageName);

  return (
    <span className="cell-cicImage">
      <i className={iconClass} style={{ fontSize: "16px" }}></i>
    </span>
  );
};
